import { cn } from '@/lib/utils';

export type BadgeTone = 'neutral' | 'accent' | 'success' | 'warning' | 'info' | 'danger';

const TONES: Record<BadgeTone, string> = {
  neutral: 'bg-tertiary text-muted-foreground ring-border',
  accent: 'bg-accent/10 text-accent ring-accent/30',
  success: 'bg-success/10 text-success ring-success/30',
  warning: 'bg-warning/10 text-warning ring-warning/30',
  info: 'bg-info/10 text-info ring-info/30',
  danger: 'bg-destructive/10 text-destructive ring-destructive/30',
};

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
}

/** Small status / metadata pill. Status tones are semantic only. */
export function Badge({ tone = 'neutral', className, children, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium leading-4 ring-1 ring-inset',
        TONES[tone],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}

/** Maps a post's lifecycle status to its semantic badge tone. */
export function postStatusTone(status: string): BadgeTone {
  switch (status) {
    case 'published':
      return 'success';
    case 'scheduled':
    case 'queued':
      return 'info';
    case 'publishing':
      return 'accent';
    case 'failed':
      return 'danger';
    default:
      return 'neutral';
  }
}
